import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { MAINTENANCE_MESSAGE, isMaintenanceStatus, toFriendlyErrorMessage } from "../../../utils/network";

const serverUrl = process.env.REACT_APP_SERVER_HOST;
const TOKEN_KEY = "auth_token";

const LoginPage = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    try {
      const res = await fetch(`${serverUrl}/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });

      if (!res.ok) {
        if (isMaintenanceStatus(res.status)) {
          throw new Error(MAINTENANCE_MESSAGE);
        }

        if (res.status === 401 || res.status === 403) {
          throw new Error("Invalid credentials");
        }
        throw new Error(`Login failed (${res.status})`);
      }

      const data = await res.json();
      const token = typeof data?.token === "string" ? data.token.trim() : "";
      if (!token) {
        throw new Error("No JWT token returned by server");
      }

      sessionStorage.setItem(TOKEN_KEY, token);
      navigate("/dashboard");
    } catch (err) {
      const friendlyMessage = toFriendlyErrorMessage(err, "Unable to login right now. Please try again.");
      setError(friendlyMessage);
    }
  };

  return (
    <div style={{ maxWidth: "350px", margin: "80px auto", padding: "30px", border: "1px solid #ccc", borderRadius: "8px", fontFamily: "Arial, sans-serif" }}>
      <h2>Login</h2>
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: "15px" }}>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Username"
            required
            style={{ width: "100%", padding: "8px" }}
          />
        </div>
        <div style={{ marginBottom: "15px" }}>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            required
            style={{ width: "100%", padding: "8px" }}
          />
        </div>
        <button type="submit" style={{ width: "100%", padding: "10px", background: "#007bff", color: "#fff", border: "none", borderRadius: "4px" }}>
          Login
        </button>
        {error && <div style={{ color: "red", marginTop: "10px" }}>{error}</div>}
      </form>
    </div>
  );
};

export default LoginPage;
